import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { getConstants } from '@/services'

export const useConstantStore = defineStore('constant', () => {
  const activeCardCategory = ref('123')
  const cards = ref([])
  const characters = ref([])
  const skins = ref([])
  const islands = ref([])
  const tasks = ref([])
  const language = 'en'

  const cardCategories = {
    crew: {
      en: 'Crew',
      tr: 'Mürettebat'
    },
    weapon: {
      en: 'Weapon',
      tr: 'Silah'
    },
    defense: {
      en: 'Armor and Defense',
      tr: 'Zırh ve Savunma'
    },
    special: {
      en: 'Special',
      tr: 'Özel Yetenekler'
    }
  }

  const getCategoryName = (category, language) => {
    return cardCategories[category][language]
  }

  const getCategoryCards = (category) => {
    return cards.value.filter((c) => c.category === category)
  }

  const fetchConstants = () => {
    return new Promise(async (resolve) => {
      const res = await getConstants()
      cards.value = res.data.cards
      characters.value = res.data.characters
      skins.value = res.data.skins
      islands.value = res.data.islands
      tasks.value = res.data.tasks

      res.data.tasks.forEach(element => {
        const i = islands.value.findIndex((c) => c.id === element.island_id)

        if (islands.value[i]['tasks'] === undefined) {
          islands.value[i]['tasks'] = [];
        }
        islands.value[i]['tasks'].push(element);        
      });

      console.log('CONSTANTS RESPONSE: ', res)
      console.log('TASKS', tasks)

      activeCardCategory.value = '123'

      setTimeout(() => {
        resolve(true)
      }, 500)
    })
  }

  function getFacilityById(facilityId) {
    const facility = facilities.value.find((f) => f.id === facilityId)
    return facility
  }

  function chageActiveCategory(constantId) {
    activeCategoryId.value = constantId
  }

  function chageCardActiveCategory(constantId) {
    activeCardCategoryId.value = constantId
  }

  const getCharacterImage = (characterId) => {
    // return characters.find((c) => c.id == characterId)['image']
    return characters[characterId]['image']
  }

  const getCharacter = (characterId) => {
    return characters.value.find((c) => c.id == characterId)
  }

  const selectedCategory = computed(() => {
    if (activeCategoryId.value !== -1) {
      const res = facilities.value.filter((facility) => {
        return facility.constant_id === activeCategoryId.value
      })
      return res
    }
    return []
  })

  const selectedCardCategory = computed(() => {
    if (activeCardCategoryId.value !== -1) {
      const res = cards.value.filter((card) => {
        return card.card_constant_id === activeCardCategoryId.value
      })
      return res
    }
    return []
  })

  return {
    activeCardCategory,
    cards,
    characters,
    skins,
    islands,
    tasks,
    cardCategories, 
    getCategoryName,
    getCategoryCards,
    fetchConstants,
    getFacilityById,
    chageActiveCategory,
    chageCardActiveCategory,
    getCharacterImage,
    getCharacter
  }
})
